<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
  <!-- 全局悬浮按钮 -->
  <GlobalFloatButton />
</template>
<script lang="ts" setup>
import zhCN from "ant-design-vue/es/locale/zh_CN"; //引入antd中文包
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { speak, stopSpeech, pauseSpeech, resumeSpeech } from "@/utils/speech";
import { onMounted } from "vue";
import GlobalFloatButton from "@/components/GlobalFloatButton.vue";

dayjs.locale("zh-cn");

const locale = zhCN;

onMounted(() => {
  speak("欢迎使用轻食易安智能体AI芬拣系统");
});
</script>

<style lang="less">
#app {
  height: 100%;
  width: 100%;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}
</style>
